module.exports = __webpack_public_path__ + "21546d802d508f3d358082d85bc0d9f1.ttf";